import defaultsDeep from "lodash/fp/defaultsDeep";

class Chartie {
  constructor() {
    this.pieChartColors = [
      "#26c1c9",
      "#00afec",
      "#ee71a9",
      "#fcc58e",
      "#ab7df6",
    ];
  }
  sortByValue(data) {
    return data.sort((a, b) => b - a);
  }
  getOptionsWithDefault(...options) {
    return defaultsDeep({
      chart: {
        height: 450,
        x: (d) => new Date(d.day),
        y: (d) => d.value,
        margin: {
          top: 50,
          left: 80,
          bottom: 50,
          right: 20,
        },
        xAxis: {
          tickPadding: 20,
          showMaxMin: false,
          tickFormat: (d) => d3.time.format("%x")(new Date(d)),
        },
        yAxis: {
          tickPadding: 7,
          showMaxMin: false,
          axisLabelDistance: -10,
        },
        pointSize: 16,
        tooltip: {
          gravity: "s",
        },
      },
    })(...options);
  }
}

export default Chartie;



// WEBPACK FOOTER //
// ./src/services/chartie/chartie.service.js